import { Component, Inject } from '@angular/core';

import { of } from 'rxjs';
import { map, mergeMap } from 'rxjs/operators';

import { ContextService } from '../../../technical-modules/context/services/context.service';
import { UserService } from '../../../data-domains/humain/user/services/user.service';

@Component({
	selector: 'test-functions',
	templateUrl: 'test-functions.html',
	styleUrls: ['test-functions.css'],
})
export class TestFunctionsComponent {
	display: boolean = false;
	testMailActive: boolean = false;
	
	constructor(
		@Inject(ContextService) contextService: ContextService,
		@Inject(UserService) userService: UserService,
	) {
		let environment$ = contextService.getEnvironement();
		let display$ = environment$.pipe(
			mergeMap(
				(environment) => {
					if (environment === 'PROD') {
						return of(false);
					}
					
					let user$ = userService.getCurrentUserTLR();
					let profil$ = user$.pipe(map(user => user.profil));
					let userIsAdmin$ = profil$.pipe(map((profil) => profil === 'ADMIN'));
					
					return userIsAdmin$;
				}
			)
		);
		display$.subscribe(
			(value) => this.display = value
		);
	}
	
	onEnvelopeClick() {
		this.testMailActive = !this.testMailActive;
		(window as any).forceMailsAsTest = this.testMailActive;
	}
}